import { render } from "./ResidentDetailsEdit.vue?vue&type=template&id=6d9ac8f3&ts=true"
import script from "./ResidentDetailsEdit.ts?vue&type=script&lang=ts"
export * from "./ResidentDetailsEdit.ts?vue&type=script&lang=ts"

import "./ResidentDetailsEdit.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__